import { RefObject } from 'react';

import { Stack } from '@mui/material';
import { useVirtualizer } from '@tanstack/react-virtual';

import { ThreadDto } from '@/api/generated';
import ThreadRow from '@/components/AskMeAnything/components/threads/ThreadRow';

import { RowContainer, ThreadsContainerTitle } from './ThreadsStyle';

interface ThreadsVirtualizeProps {
  parentRef: RefObject<HTMLDivElement>;
  threads: ThreadDto[];
  setChatTitle: (title: string) => void;
  handleThreadChange: (thread: ThreadDto, willCloseThreads?: boolean) => void;
}

const ThreadsVirtualize = ({
  parentRef,
  threads,
  setChatTitle,
  handleThreadChange
}: ThreadsVirtualizeProps) => {
  const rowVirtualizer = useVirtualizer({
    count: threads.length,
    getScrollElement: () => parentRef.current,
    estimateSize: index => (!('createdAt' in threads[index]) ? 37 : 40),
    overscan: 20
  });

  return (
    <Stack
      sx={{
        height: `${rowVirtualizer.getTotalSize()}px`,
        width: '100%',
        position: 'relative'
      }}
    >
      {rowVirtualizer.getVirtualItems().map(virtualItem => {
        const thread = threads[virtualItem.index];
        const key = `${thread.id}-${thread.title}`;
        if (!('createdAt' in thread)) {
          return (
            <ThreadsContainerTitle
              key={key}
              data-index={virtualItem.index}
              ref={rowVirtualizer.measureElement}
              sx={{
                height: `${virtualItem.size}px`,
                transform: `translateY(${virtualItem.start}px)`
              }}
            >
              {thread.title}
            </ThreadsContainerTitle>
          );
        }
        return (
          <RowContainer
            key={key}
            data-index={virtualItem.index}
            ref={rowVirtualizer.measureElement}
            sx={{
              height: `${virtualItem.size}px`,
              transform: `translateY(${virtualItem.start}px)`
            }}
          >
            <ThreadRow
              thread={thread}
              setChatTitle={setChatTitle}
              originalName={thread.title || ''}
              threadId={thread.id || ''}
              onClick={() => handleThreadChange(thread, true)}
              handleThreadChange={handleThreadChange}
            />
          </RowContainer>
        );
      })}
    </Stack>
  );
};

export default ThreadsVirtualize;
